import { Text } from '@/_components';
import type { InvoiceQuerySchema } from '@/_pages/invoices/shared/schemas';

import { InvoiceDetailsEmailToSection } from './invoice-details-email-to-section';
import { InvoiceDetailsTabHeader } from './invoice-details-tab-header';

type InvoiceDetailsDetailTabProps = {
  invoice: InvoiceQuerySchema;
  billingAddressBlocks: string[];
};

export function InvoiceDetailsDetailTab({ invoice, billingAddressBlocks }: InvoiceDetailsDetailTabProps) {
  return (
    <div className="space-y-2 px-2 py-2">
      <InvoiceDetailsTabHeader invoice={invoice} />

      <div className="grid grid-cols-1 gap-2 lg:grid-cols-2 lg:items-start">
        <div>
          <Text className="text-c-card-muted mb-1 text-[10px] font-semibold tracking-wide uppercase">Bill To</Text>
          <div className="border-c-border rounded border p-2">
            <Text className="text-c-card-foreground text-xs">
              {invoice.client?.account_number ? `Account: ${invoice.client.account_number}` : 'Account: —'}
            </Text>
            <Text className="text-c-card-foreground mt-1 text-sm font-semibold">{invoice.client?.name ?? '—'}</Text>
            {billingAddressBlocks.length > 0 ? (
              billingAddressBlocks.map((address, index) => (
                <Text key={index} className="text-c-card-muted mt-1 text-xs whitespace-pre-line">
                  {address}
                </Text>
              ))
            ) : (
              <Text className="text-c-card-muted mt-1 text-xs">—</Text>
            )}
          </div>
        </div>

        <InvoiceDetailsEmailToSection invoice={invoice} />
      </div>
    </div>
  );
}
